import type { ApiNddAvailabilityResponse, ApiPhysicalGiftCardConfigResponse } from '../dto/storeGiftCard.dto';
import type { NddAvailabilityResult, PhysicalGiftCardConfig } from '../../domain/models/storeGiftCard.types';

export const adaptNddAvailabilityToDomain = (
  dto: ApiNddAvailabilityResponse
): NddAvailabilityResult => {
  return {
    hasError: Boolean(dto?.hasError),
    estimatedDeliveryDate: dto?.expectedDeliveryDate,
  };
};

export const adaptConfigToDomain = (
  dto: ApiPhysicalGiftCardConfigResponse
): PhysicalGiftCardConfig => ({
  customizationId: dto?.customizationId ? String(dto.customizationId) : null,
  displayAmounts: Array.isArray(dto?.displayAmounts) ? dto.displayAmounts : [],
});